export default {
  publishingStatus: { have: { id: { in: ['GHPIUfghTe'] } } },
};
